import { useEffect } from 'react'

import { getEnhancedSettingsKey } from 'Pods/ThreeDStudio/Shared/Utils/getEnhancedSettingsKey'
import { getNextEnhancedSchema } from 'Pods/ThreeDStudio/Shared/Utils/getNextEnhancedSchema'
import { getNextGenerationSchema } from 'Pods/ThreeDStudio/Shared/Utils/getNextGenerationSchema'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { setEnhancedModelSchema, setGenerationModelSchema } from 'Pods/ThreeDStudio/Store/actions/schema'

export default function useActiveModelSchema({
  enableHunyuanSegmentation = false,
  enableMeshyRemesh = false,
} = {}) {
  const generationAction = useThreeDStudioStore(state => state.schema.generationAction)
  const generationProvider = useThreeDStudioStore(state => state.schema.generationProvider)
  const enhancedAction = useThreeDStudioStore(state => state.schema.enhancedAction)
  const enhancedProvider = useThreeDStudioStore(state => state.schema.enhancedProvider)
  const activeViewerSidebarTab = useThreeDStudioStore(state => state.ui.activeViewerSidebarTab)
  const polygonType = useThreeDStudioStore(state => state.modelSettings.polygonType)
  const isSmartLowPoly = useThreeDStudioStore(state => state.modelSettings.isSmartLowPoly)
  const extraQuality = useThreeDStudioStore(state => state.modelSettings.extraQuality)
  const material = useThreeDStudioStore(state => state.modelSettings.material)
  const isRemeshSmartLowPoly = useThreeDStudioStore(state => state.remeshSettings.isSmartLowPoly)
  const viewerFileFormat = useThreeDStudioStore(state => state.viewer.fileFormat)

  useEffect(() => {
    const modelSettings = useThreeDStudioStore.getState().modelSettings
    const nextGenerationSchema = getNextGenerationSchema(generationAction, modelSettings)
    if (nextGenerationSchema) {
      setGenerationModelSchema(nextGenerationSchema)
    }
  }, [
    polygonType,
    generationAction,
    generationProvider,
    isSmartLowPoly,
    extraQuality,
    material,
  ])

  useEffect(() => {
    const settingsKey = getEnhancedSettingsKey(activeViewerSidebarTab, enhancedAction)
    const enhancedSettings = settingsKey
      ? useThreeDStudioStore.getState()[settingsKey] || {}
      : {}
    const nextEnhancedSchema = getNextEnhancedSchema(
      enhancedAction,
      { ...enhancedSettings, fileFormat: viewerFileFormat },
      { enableHunyuanSegmentation, enableMeshyRemesh },
    ) || null
    setEnhancedModelSchema(nextEnhancedSchema)
  }, [
    isRemeshSmartLowPoly,
    enhancedAction,
    enhancedProvider,
    activeViewerSidebarTab,
    viewerFileFormat,
    enableHunyuanSegmentation,
    enableMeshyRemesh,
  ])
}
